import { render } from "./ProductColors.vue?vue&type=template&id=580e0d0a"
import script from "./ProductColors.vue?vue&type=script&lang=js"
export * from "./ProductColors.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__